import YouTubeVideo from '../util/YouTubeVideo'

const YOUTUBE_VIDEOS: YouTubeVideo[] = [
  {
    videoId: 'G-SyAOIcvpI',
    snippet: {
      publishedAt: '2023-09-30T11:27:10Z',
      title: 'How to put the fingers on the string!',
      description: 'The first song with fingers on the string on the violin for children!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/G-SyAOIcvpI/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/G-SyAOIcvpI/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/G-SyAOIcvpI/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'fZdw0N03taw',
    snippet: {
      publishedAt: '2023-09-30T10:05:44Z',
      title: 'Cum să punem degetele pe coardă!',
      description: 'Prima piesă cu degetele pe coardă pentru copii!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/fZdw0N03taw/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/fZdw0N03taw/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/fZdw0N03taw/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'dMmFeZH_ROI',
    snippet: {
      publishedAt: '2023-03-01T15:30:30Z',
      title: 'Cântecul Arcușului: Bow Hold Song (Română & English)',
      description:
        'Folosește acest cântec ca să exersezi ținerea arcușului în timp că îți imaginezi că ești pescar! Melodia este similară cu cântecul "Vulpe tu mi-ai furat gâsca..."',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/dMmFeZH_ROI/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/dMmFeZH_ROI/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/dMmFeZH_ROI/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'dRQiNdIoL84',
    snippet: {
      publishedAt: '2023-02-04T12:54:49Z',
      title: 'Beginner Bow Exercise for Flexibility and Control',
      description:
        'I do this exercise with my students when they finish preparatory violin work (pre-twinkle) and are learning the Twinkle Variations.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/dRQiNdIoL84/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/dRQiNdIoL84/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/dRQiNdIoL84/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'fdkehCWawWg',
    snippet: {
      publishedAt: '2023-02-04T13:15:54Z',
      title: 'Cântecul Viorii (Parts of the Violin Song)',
      description:
        'Părțile viorii: Bărbia = the chinrest Cordarul = the tailpiece Călușul = the bridge Corzile = the strings Limba = the fingerboard ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/fdkehCWawWg/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/fdkehCWawWg/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/fdkehCWawWg/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'DrX8v53t4-A',
    snippet: {
      publishedAt: '2023-01-17T15:03:51Z',
      title:
        'How to install fine-tuners on your violin! (Cum se instalează fixurile de vioară pe vioară!)',
      description:
        'You will need: fine-tuners, a flat-head screwdriver and pliers. 1. Loosen the string 2. Unscrew the fine-tuner 3. Insert the fine-tuner ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/DrX8v53t4-A/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/DrX8v53t4-A/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/DrX8v53t4-A/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'LwyeMCVhxEQ',
    snippet: {
      publishedAt: '2022-07-13T12:52:54Z',
      title: 'Oac Oac (Romanian)',
      description:
        'Un aranjament original al doamnei Johnson. Ce petrecere frumoasă e la margine de lac Broscărimea bucuroasă are vin și ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/LwyeMCVhxEQ/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/LwyeMCVhxEQ/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/LwyeMCVhxEQ/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'cV18iPdp1nA',
    snippet: {
      publishedAt: '2020-08-18T22:03:02Z',
      title: 'Original Song: In My Garden',
      description:
        "This is my first original children's song: In My Garden. This one is for all the kids that love bugs and nature as much as I do!",
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/cV18iPdp1nA/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/cV18iPdp1nA/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/cV18iPdp1nA/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'vwaWFOoLGdk',
    snippet: {
      publishedAt: '2020-04-17T17:32:10Z',
      title: 'Zin! Zin! Zin! a Violin',
      description:
        'Follow along as we read the book Zin! Zin! Zin! a Violin, and watch a musician play each instrument as it appears in the book!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/vwaWFOoLGdk/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/vwaWFOoLGdk/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/vwaWFOoLGdk/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'SHG8TsM_-Bk',
    snippet: {
      publishedAt: '2020-04-07T22:57:48Z',
      title: "Music Class: Soldier's Joy Move it",
      description: 'Match my motions!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/SHG8TsM_-Bk/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/SHG8TsM_-Bk/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/SHG8TsM_-Bk/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'LJXejdfZXTk',
    snippet: {
      publishedAt: '2020-07-08T17:49:28Z',
      title: 'The Snail Song: Melc, Melc, Codobelc',
      description:
        'Melc, melc, codobelc Scoate coarne bouresti, Si te du la balta, Si bea apa calda, Si te du la Dunare, Si bea apa tulbure, Si te suie ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/LJXejdfZXTk/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/LJXejdfZXTk/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/LJXejdfZXTk/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'hNqLF8niKto',
    snippet: {
      publishedAt: '2022-07-13T12:50:26Z',
      title: 'Oac Oac (English)',
      description:
        "Original musical arrangement, as well as translated and adapted to English by Ms. Johnson. Oac Oac is a Romanian children's ...",
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/hNqLF8niKto/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/hNqLF8niKto/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/hNqLF8niKto/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'if4MU7_3bOw',
    snippet: {
      publishedAt: '2020-07-27T19:33:15Z',
      title: 'Moto Mendez - Cueca Chapaca',
      description:
        'The inspiration for this arrangement came from this video: https://www.youtube.com/watch?v=vxCTDoS5V1w English translation ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/if4MU7_3bOw/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/if4MU7_3bOw/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/if4MU7_3bOw/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'XQ-yVsm80Ec',
    snippet: {
      publishedAt: '2022-08-18T15:13:04Z',
      title: 'Packing for a Picnic with Bach',
      description:
        "In this video I'm playing the Gigue from Bach's Suite no. 3 for solo cello arranged for viola. Children can learn the form of the piece ...",
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/XQ-yVsm80Ec/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/XQ-yVsm80Ec/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/XQ-yVsm80Ec/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'FU3MVLYk7hc',
    snippet: {
      publishedAt: '2020-09-28T20:48:41Z',
      title: 'Warm-Up and No More Pie Lesson 1',
      description: 'Warm up your breath and your voice and sing echo song No More Pie with me!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/FU3MVLYk7hc/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/FU3MVLYk7hc/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/FU3MVLYk7hc/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'VjR6ZCysUew',
    snippet: {
      publishedAt: '2020-10-13T21:36:48Z',
      title: 'Warm Up and No More Pie Lesson 2',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/VjR6ZCysUew/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/VjR6ZCysUew/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/VjR6ZCysUew/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'zCa3UlA28Ho',
    snippet: {
      publishedAt: '2020-11-09T21:13:22Z',
      title: 'Warm Up and No More Pie Lesson 3',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/zCa3UlA28Ho/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/zCa3UlA28Ho/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/zCa3UlA28Ho/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '_vZMNHdBADQ',
    snippet: {
      publishedAt: '2020-04-07T22:57:40Z',
      title: 'K1 Vocal Warm-Up: Warm Up and Wise Old Owl Lesson 1',
      description:
        "Wise Old Owl: One of these days, Look up and see. A wise old owl, Living in a Tree. He'll look at you. He''ll look at me. Those two ...",
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/_vZMNHdBADQ/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/_vZMNHdBADQ/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/_vZMNHdBADQ/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'UywVzlmFHVM',
    snippet: {
      publishedAt: '2020-04-10T20:12:21Z',
      title: 'K1 Vocal Warm-Up: Warm-Up and Wise Old Owl Lesson 2',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/UywVzlmFHVM/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/UywVzlmFHVM/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/UywVzlmFHVM/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'AKjCUyBF-Yw',
    snippet: {
      publishedAt: '2020-04-26T20:43:06Z',
      title: 'K1 Vocal Warm-Up: Warm-Up, Wise Old Owl and Tongo Lesson 3',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/AKjCUyBF-Yw/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/AKjCUyBF-Yw/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/AKjCUyBF-Yw/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'uv-X2SqE72k',
    snippet: {
      publishedAt: '2020-05-01T22:17:24Z',
      title: 'K1 Vocal Warm-Up: Warm Up and Wise Old Owl Lesson 4',
      description:
        'Get ready to sing by warming up your body and your voice, then sing echo song Wise Old Owl! Warm-Up Contains: Cookie Dough, Signal Sounds, Solfege',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/uv-X2SqE72k/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/uv-X2SqE72k/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/uv-X2SqE72k/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'aCbJHDsfW8Q',
    snippet: {
      publishedAt: '2020-04-07T22:57:36Z',
      title: 'K2 Vocal Warm-Up: Warm Up and Tongo Lesson 1',
      description:
        'Tongo Song: Tongo! Tongo! Jimnee bye bye oh Tongo Oom ba de kim bye oh Ooh a lay Mah le ka ah lo way ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/aCbJHDsfW8Q/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/aCbJHDsfW8Q/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/aCbJHDsfW8Q/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'vmRDHFKycEo',
    snippet: {
      publishedAt: '2020-04-10T20:11:53Z',
      title: 'K2 Vocal Warm-Up: Warm Up and Tongo Lesson 2',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/vmRDHFKycEo/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/vmRDHFKycEo/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/vmRDHFKycEo/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '4ukiTgtq_pA',
    snippet: {
      publishedAt: '2020-05-01T22:17:01Z',
      title: 'K2 Vocal Warm-Up: Warm-Up and Tongo Lesson 3',
      description:
        'Get ready to sing by warming up your body and your voice, then sing echo song Tongo! In Warm-Up: Cookie Dough, Signal Sounds, Solfege',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/4ukiTgtq_pA/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/4ukiTgtq_pA/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/4ukiTgtq_pA/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'gCL38oIu5UY',
    snippet: {
      publishedAt: '2020-05-11T18:32:22Z',
      title: 'K2 Vocal Warm-Up: Warm Up and John the Rabbit Lesson 1',
      description:
        'Get ready to sing by warming up your voice and your breath, then sing the call-and-response song John the Rabbit! Warm-Up Contains: Signal Sounds, Leaky Faucet breaths',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/gCL38oIu5UY/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/gCL38oIu5UY/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/gCL38oIu5UY/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'IzFw7iIKPEM',
    snippet: {
      publishedAt: '2020-05-15T17:46:22Z',
      title: 'K2 Vocal Warm-Up: Warm-Up and John the Rabbit Lesson 2',
      description:
        'Get ready to sing by warming up your body, your voice and your breath! 1. Move-it Kreisler Liebesfreud 2. Ice Cream Sundae pitch ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/IzFw7iIKPEM/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/IzFw7iIKPEM/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/IzFw7iIKPEM/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'hHwd_RWh9aA',
    snippet: {
      publishedAt: '2020-05-25T22:24:01Z',
      title: 'Longer K2 Vocal Warm-Up Lesson 1',
      description:
        'Get ready to sing by warming up your body, your voice and your breath! Beats, Ice-Cream Sundae story and Leaky Faucet breaths',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/hHwd_RWh9aA/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/hHwd_RWh9aA/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/hHwd_RWh9aA/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'LqY52kuF6sc',
    snippet: {
      publishedAt: '2020-05-29T19:45:07Z',
      title: 'Longer K2 Vocal Warm-Up Lesson 2',
      description:
        'Get ready to sing by warming up your body, your voice and your breath! Beats, Ice-Cream Sundae story, & Leaky Faucet Breaths',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/LqY52kuF6sc/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/LqY52kuF6sc/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/LqY52kuF6sc/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '6cjJjUKWhZo',
    snippet: {
      publishedAt: '2020-06-05T15:48:31Z',
      title: 'Longer K2 Vocal Warm-Up Lesson 3',
      description: "Beats, Comin' Round the Mountain and Balloon Breaths!",
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/6cjJjUKWhZo/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/6cjJjUKWhZo/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/6cjJjUKWhZo/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'mgnAL0KrFCw',
    snippet: {
      publishedAt: '2020-05-26T15:08:04Z',
      title: 'Music Class: Purple Light Lesson 1',
      description:
        'Original arrangement by Ms. Johnson of Echo Song Purple Light -see source here- https://www.youtube.com/watch?v=E4iithCns64',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/mgnAL0KrFCw/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/mgnAL0KrFCw/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/mgnAL0KrFCw/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'anxEkZL-fuE',
    snippet: {
      publishedAt: '2020-06-01T15:30:41Z',
      title: 'Music Class: Purple Light Lesson 2',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/anxEkZL-fuE/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/anxEkZL-fuE/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/anxEkZL-fuE/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '1GWKA5WQr1k',
    snippet: {
      publishedAt: '2020-06-08T20:15:16Z',
      title: 'Music Class: Purple Light Lesson 3',
      description: 'This is an echo song! I included the lyrics as subtitles.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/1GWKA5WQr1k/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/1GWKA5WQr1k/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/1GWKA5WQr1k/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'AI_j60psE8g',
    snippet: {
      publishedAt: '2020-06-15T16:56:32Z',
      title: 'Music Class: Purple Light Lesson 4',
      description: 'This is a sing after me song!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/AI_j60psE8g/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/AI_j60psE8g/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/AI_j60psE8g/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'wRF9RfFuo9E',
    snippet: {
      publishedAt: '2020-05-18T17:59:56Z',
      title: 'Music Class: Sir Duke Lesson 1',
      description:
        'I got the live clip of Stevie Wonder from this video: https://www.youtube.com/watch?v=ArgHvssVfF8.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/wRF9RfFuo9E/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/wRF9RfFuo9E/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/wRF9RfFuo9E/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '63ZHxdO5u34',
    snippet: {
      publishedAt: '2020-06-03T17:13:08Z',
      title: 'Music Class: Sir Duke Lesson 2',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/63ZHxdO5u34/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/63ZHxdO5u34/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/63ZHxdO5u34/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '3Gcj1Uj2Q9U',
    snippet: {
      publishedAt: '2020-05-18T18:16:02Z',
      title: 'Music Class: Sir Duke Lesson 3',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/3Gcj1Uj2Q9U/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/3Gcj1Uj2Q9U/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/3Gcj1Uj2Q9U/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'Y05SmgRHHoE',
    snippet: {
      publishedAt: '2020-06-02T20:27:39Z',
      title: 'Music Class: Funny Face Lesson 1',
      description:
        'Funny Face by Julia Donaldson, arranged by Susanna Johnson-Chelaru. Verse 1 Lyrics: Pull a funny face. Move your eyes and ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/Y05SmgRHHoE/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/Y05SmgRHHoE/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/Y05SmgRHHoE/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'Sug9kQVuJak',
    snippet: {
      publishedAt: '2020-06-09T15:55:36Z',
      title: 'Music Class: Funny Face Lesson 2',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/Sug9kQVuJak/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/Sug9kQVuJak/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/Sug9kQVuJak/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'JcpDpruZkr0',
    snippet: {
      publishedAt: '2020-06-16T16:46:39Z',
      title: 'Music Class: Funny Face Lesson 3',
      description:
        'Funny Face by Julia Donaldson. Pull a funny face. Move your eyes and nose and mouth all over the place. First you smile like a ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/JcpDpruZkr0/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/JcpDpruZkr0/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/JcpDpruZkr0/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'Dg4zncU9eDU',
    snippet: {
      publishedAt: '2020-09-21T20:10:50Z',
      title: 'All Around the Kitchen- Lesson 1',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/Dg4zncU9eDU/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/Dg4zncU9eDU/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/Dg4zncU9eDU/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'bTFPz0SzZSo',
    snippet: {
      publishedAt: '2020-10-06T17:50:18Z',
      title: 'All Around the Kitchen Lesson 2',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/bTFPz0SzZSo/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/bTFPz0SzZSo/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/bTFPz0SzZSo/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'fcVs7w6VTE8',
    snippet: {
      publishedAt: '2020-10-19T21:17:18Z',
      title: 'All Around the Kitchen Lesson 3',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/fcVs7w6VTE8/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/fcVs7w6VTE8/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/fcVs7w6VTE8/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '4AdxnRS6dNA',
    snippet: {
      publishedAt: '2020-05-05T17:43:36Z',
      title: 'Music Class: Senwa Dedende Lesson 1',
      description:
        'My source for the Senwa Dedende clip at the beginning of the video is this youtube video: https://youtu.be/1hjopA6xdXc.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/4AdxnRS6dNA/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/4AdxnRS6dNA/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/4AdxnRS6dNA/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'Utp1AHpNH9k',
    snippet: {
      publishedAt: '2020-05-05T17:43:59Z',
      title: 'Music Class: Senwa Dedende Lesson 2',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/Utp1AHpNH9k/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/Utp1AHpNH9k/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/Utp1AHpNH9k/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '8NHlaXWUx5E',
    snippet: {
      publishedAt: '2020-05-19T17:09:52Z',
      title: 'Music Class: Senwa Dedende Lesson 3',
      description: 'With claps!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/8NHlaXWUx5E/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/8NHlaXWUx5E/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/8NHlaXWUx5E/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '_mGYMaEILtY',
    snippet: {
      publishedAt: '2020-05-26T20:00:14Z',
      title: 'Music Class: Senwa Dedende Lesson 4',
      description: 'With claps AND stomp!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/_mGYMaEILtY/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/_mGYMaEILtY/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/_mGYMaEILtY/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'A4IRzyQc4Ec',
    snippet: {
      publishedAt: '2020-04-07T22:57:32Z',
      title: 'Music Class: Juanito Lesson 1',
      description:
        'Lyrics: Juanito cuando baila, Baila, baila, baila! Juanito cuando baila, Baila con el dedito, Con el dedito, ito, ito.. Asi baila Juanito.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/A4IRzyQc4Ec/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/A4IRzyQc4Ec/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/A4IRzyQc4Ec/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '-8ydNyzl1HA',
    snippet: {
      publishedAt: '2020-04-13T21:44:00Z',
      title: 'Music Class: Juanito Lesson 2',
      description:
        'Lyrics: Juanito cuando baila, Baila, baila, baila! Juanito cuando baila, Baila con el dedito, Con el dedito, ito, ito.. Asi baila Juanito.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/-8ydNyzl1HA/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/-8ydNyzl1HA/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/-8ydNyzl1HA/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '4XCqMudxNNQ',
    snippet: {
      publishedAt: '2020-04-27T21:57:13Z',
      title: 'Music Class: Juanito Lesson 3',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/4XCqMudxNNQ/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/4XCqMudxNNQ/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/4XCqMudxNNQ/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'eXaPqzEGfho',
    snippet: {
      publishedAt: '2020-04-27T22:13:36Z',
      title: 'Music Class: Juanito Lesson 4',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/eXaPqzEGfho/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/eXaPqzEGfho/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/eXaPqzEGfho/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'QyF8h2KG-Gc',
    snippet: {
      publishedAt: '2020-05-18T19:25:38Z',
      title: 'Rhythm Unit:  Lesson 1- Beats and Doubles!',
      description: 'Learn to read beats and doubles rhythms. (Quarter notes and eighth notes!)',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/QyF8h2KG-Gc/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/QyF8h2KG-Gc/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/QyF8h2KG-Gc/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'XSOUIXxWWxk',
    snippet: {
      publishedAt: '2020-05-29T16:12:54Z',
      title: 'Rhythm Unit: Lesson 2 - Rests and Longs',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/XSOUIXxWWxk/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/XSOUIXxWWxk/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/XSOUIXxWWxk/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '8bOxJp6OlGM',
    snippet: {
      publishedAt: '2020-06-09T19:10:59Z',
      title: 'Rhythm Unit: Lesson 3 - Four Beat Patterns - Beats and Doubles!',
      description: 'Learn to read quarter notes and eighth notes in four beat patterns!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/8bOxJp6OlGM/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/8bOxJp6OlGM/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/8bOxJp6OlGM/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'uDC8vKLUA9w',
    snippet: {
      publishedAt: '2020-06-10T18:04:20Z',
      title: 'Rhythm Unit: Lesson 4- four beat patterns: beats, rests & longs!',
      description: 'Learn to read quarter notes, quarter note rests and whole notes.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/uDC8vKLUA9w/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/uDC8vKLUA9w/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/uDC8vKLUA9w/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'aUpD5iOyJPg',
    snippet: {
      publishedAt: '2020-09-22T21:21:14Z',
      title: 'Music Class: A Ram Sam Sam Lesson 1',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/aUpD5iOyJPg/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/aUpD5iOyJPg/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/aUpD5iOyJPg/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '5Gjl77VNZys',
    snippet: {
      publishedAt: '2020-10-06T17:25:32Z',
      title: 'Music Class: A Ram Sam Sam Lesson 2',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/5Gjl77VNZys/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/5Gjl77VNZys/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/5Gjl77VNZys/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '633e3vyc8Cg',
    snippet: {
      publishedAt: '2020-10-19T21:06:42Z',
      title: 'Music Class: A Ram Sam Sam Lesson 3',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/633e3vyc8Cg/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/633e3vyc8Cg/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/633e3vyc8Cg/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'tqrXkQflbj0',
    snippet: {
      publishedAt: '2020-05-15T22:55:51Z',
      title: 'Harmony Unit: Lesson 1 - D and A with ukulele',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/tqrXkQflbj0/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/tqrXkQflbj0/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/tqrXkQflbj0/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'C-dKfyEw7pg',
    snippet: {
      publishedAt: '2020-05-25T20:47:06Z',
      title: 'Harmony Unit: Lesson 2- 1, 4, & 5 bass-line!',
      description: 'Forgive the not-so-in-tune ukulele. My ukulele will NOT stay in tune.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/C-dKfyEw7pg/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/C-dKfyEw7pg/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/C-dKfyEw7pg/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'VQ59EtVr6UM',
    snippet: {
      publishedAt: '2020-09-28T20:44:21Z',
      title: 'Vocal warm up: Basketball and Charlie over the Ocean Lesson 1',
      description: 'Warm up your voice and then sing echo song Charlie over the Ocean with me!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/VQ59EtVr6UM/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/VQ59EtVr6UM/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/VQ59EtVr6UM/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'baHYIHbGXOE',
    snippet: {
      publishedAt: '2020-10-13T21:37:46Z',
      title: 'Vocal Warm-Up: Basketball and Charlie over the Ocean Lesson 2',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/baHYIHbGXOE/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/baHYIHbGXOE/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/baHYIHbGXOE/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'UvM--vKF4ns',
    snippet: {
      publishedAt: '2020-11-09T20:57:59Z',
      title: 'Vocal Warm-Up: Leaky Faucet and Charlie over the Ocean Lesson 3',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/UvM--vKF4ns/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/UvM--vKF4ns/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/UvM--vKF4ns/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'K0ldZegCI7w',
    snippet: {
      publishedAt: '2020-04-14T20:10:26Z',
      title: 'Music Class: One Light, One Sun Karaoke',
      description:
        'Original Song by Raffi: One Light, one sun One sun lighting everyone One world turning One world turning everyone One world, ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/K0ldZegCI7w/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/K0ldZegCI7w/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/K0ldZegCI7w/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '0zOvKuNn9mA',
    snippet: {
      publishedAt: '2020-05-11T20:24:24Z',
      title: 'Beethoven Lives Upstairs Tracks 13-14',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/0zOvKuNn9mA/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/0zOvKuNn9mA/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/0zOvKuNn9mA/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '0atgq67Dm58',
    snippet: {
      publishedAt: '2020-04-08T20:53:22Z',
      title: 'Everything Grows Karaoke',
      description: 'Now you sing on your own!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/0atgq67Dm58/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/0atgq67Dm58/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/0atgq67Dm58/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'W2UA7sCYzyM',
    snippet: {
      publishedAt: '2020-04-27T23:45:22Z',
      title: 'Beethoven Lives Upstairs Tracks 9-12 with words',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/W2UA7sCYzyM/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/W2UA7sCYzyM/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/W2UA7sCYzyM/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '_KExCRTieNc',
    snippet: {
      publishedAt: '2020-09-14T19:48:58Z',
      title: 'Move It The Wedding of Kije',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/_KExCRTieNc/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/_KExCRTieNc/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/_KExCRTieNc/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'aOM7kbzFruc',
    snippet: {
      publishedAt: '2020-10-26T19:42:45Z',
      title: 'Glockenspiel Introduction',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/aOM7kbzFruc/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/aOM7kbzFruc/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/aOM7kbzFruc/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'rUACs4A6st8',
    snippet: {
      publishedAt: '2020-04-14T20:10:31Z',
      title: 'Music Class: One Light, One Sun with Vocals',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/rUACs4A6st8/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/rUACs4A6st8/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/rUACs4A6st8/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'YSOVHy5QhDM',
    snippet: {
      publishedAt: '2020-05-08T19:27:23Z',
      title: 'Violin: Five Notes Written Staff',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/YSOVHy5QhDM/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/YSOVHy5QhDM/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/YSOVHy5QhDM/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'KSxFJEWrfBQ',
    snippet: {
      publishedAt: '2020-05-11T18:28:50Z',
      title: 'Go Round the Mountain',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/KSxFJEWrfBQ/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/KSxFJEWrfBQ/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/KSxFJEWrfBQ/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'lAuxgc6cJzE',
    snippet: {
      publishedAt: '2020-04-14T20:11:39Z',
      title: 'Music Class: Allee Galloo Galloo',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/lAuxgc6cJzE/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/lAuxgc6cJzE/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/lAuxgc6cJzE/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'KahvcNIUv6w',
    snippet: {
      publishedAt: '2020-04-26T23:20:28Z',
      title: 'Human Xylophone Part 3: VIOLIN 5 Line Giant Staff',
      description: '(This video is for VIOLIN PLAYERS)',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/KahvcNIUv6w/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/KahvcNIUv6w/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/KahvcNIUv6w/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'zWSEKTJwG3w',
    snippet: {
      publishedAt: '2020-05-08T17:46:48Z',
      title: 'Move It: Kreisler Liebesfreud',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/zWSEKTJwG3w/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/zWSEKTJwG3w/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/zWSEKTJwG3w/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'O_dDyQAcD7Y',
    snippet: {
      publishedAt: '2020-04-07T23:14:42Z',
      title: 'Canon in D all themes!',
      description:
        'In case anyone wants to hear how all the themes sound together :) Miss playing with you guys!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/O_dDyQAcD7Y/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/O_dDyQAcD7Y/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/O_dDyQAcD7Y/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'urnIIPh1JRA',
    snippet: {
      publishedAt: '2020-05-20T19:00:50Z',
      title: 'Go Round the Mountain: Freeze Dance!',
      description: 'Move your bodies with me!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/urnIIPh1JRA/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/urnIIPh1JRA/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/urnIIPh1JRA/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'cw1SgosvGvM',
    snippet: {
      publishedAt: '2020-04-29T18:38:11Z',
      title: 'Allee Galoo Galoo with Bugs and Animals!',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/cw1SgosvGvM/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/cw1SgosvGvM/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/cw1SgosvGvM/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'MFdmVfUSO5s',
    snippet: {
      publishedAt: '2020-04-17T00:12:28Z',
      title: 'Sing Along: The Ants Go Marching',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/MFdmVfUSO5s/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/MFdmVfUSO5s/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/MFdmVfUSO5s/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'QBWrunSVPjw',
    snippet: {
      publishedAt: '2020-12-10T21:55:50Z',
      title: 'Glockenspiel Set Up Song',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/QBWrunSVPjw/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/QBWrunSVPjw/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/QBWrunSVPjw/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'rTd6Lu9yCLw',
    snippet: {
      publishedAt: '2020-04-15T18:25:54Z',
      title: 'Music Class: Whole World with vocals',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/rTd6Lu9yCLw/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/rTd6Lu9yCLw/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/rTd6Lu9yCLw/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'f4th5Mh2knI',
    snippet: {
      publishedAt: '2020-04-07T22:57:45Z',
      title: 'Music Class: Lines and Spaces Games',
      description:
        'The five lines we use to read music are called the Staff. To make your giant staff, you need to make five lines that are 4-5 feet wide ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/f4th5Mh2knI/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/f4th5Mh2knI/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/f4th5Mh2knI/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'iggbuyBfsPA',
    snippet: {
      publishedAt: '2020-12-07T22:03:11Z',
      title: 'Hot Cross Buns practice!',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/iggbuyBfsPA/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/iggbuyBfsPA/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/iggbuyBfsPA/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'MbAPBBfXwjY',
    snippet: {
      publishedAt: '2020-04-29T18:44:37Z',
      title: 'First Grade Warm-Up Solfege',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/MbAPBBfXwjY/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/MbAPBBfXwjY/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/MbAPBBfXwjY/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'tkpHgH25KrA',
    snippet: {
      publishedAt: '2020-05-08T19:32:29Z',
      title: 'Cello Five Notes Written Staff',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/tkpHgH25KrA/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/tkpHgH25KrA/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/tkpHgH25KrA/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'u-1SdvhYZu8',
    snippet: {
      publishedAt: '2020-04-09T16:48:17Z',
      title: 'Lazy Bones',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/u-1SdvhYZu8/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/u-1SdvhYZu8/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/u-1SdvhYZu8/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'VSc3BA-iiCc',
    snippet: {
      publishedAt: '2020-04-27T00:00:58Z',
      title: 'Human Xylophone Part 3: CELLO 5 Line Giant Staff',
      description: 'This video is for Cello Players only!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/VSc3BA-iiCc/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/VSc3BA-iiCc/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/VSc3BA-iiCc/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '1YhO4hoH1Sg',
    snippet: {
      publishedAt: '2020-04-07T23:17:34Z',
      title: 'Learn to read notes: three note patterns',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/1YhO4hoH1Sg/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/1YhO4hoH1Sg/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/1YhO4hoH1Sg/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'es5A1MDM-IE',
    snippet: {
      publishedAt: '2020-04-15T18:26:01Z',
      title: 'Music Class: Whole World Karaoke',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/es5A1MDM-IE/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/es5A1MDM-IE/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/es5A1MDM-IE/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'NOB6ZufvF3g',
    snippet: {
      publishedAt: '2020-05-13T16:56:52Z',
      title: 'The Autoharp!',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/NOB6ZufvF3g/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/NOB6ZufvF3g/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/NOB6ZufvF3g/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'tPREUN1lZls',
    snippet: {
      publishedAt: '2020-05-06T20:48:17Z',
      title: 'Cello: Learn to write D E F# on staff!',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/tPREUN1lZls/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/tPREUN1lZls/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/tPREUN1lZls/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'iUYrOpaMm2A',
    snippet: {
      publishedAt: '2020-04-08T01:19:33Z',
      title: 'Cup Rhythm Game and Challenge!',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/iUYrOpaMm2A/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/iUYrOpaMm2A/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/iUYrOpaMm2A/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'Xxp5mbnSd3I',
    snippet: {
      publishedAt: '2020-04-28T21:14:17Z',
      title: 'Human Xylophone Part 4: Senwa Dedende on Giant Staff',
      description:
        'Senwa Dedende came from this source: https://www.youtube.com/watch?v=1hjopA6xdXc.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/Xxp5mbnSd3I/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/Xxp5mbnSd3I/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/Xxp5mbnSd3I/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'Q372JKHmBhs',
    snippet: {
      publishedAt: '2020-06-11T18:48:00Z',
      title: "Week 10 Warm-Up: Beats with Music, Comin' Round the Mountain & Balloon Breaths!",
      description: 'Warm up your body, voice and breath for singing!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/Q372JKHmBhs/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/Q372JKHmBhs/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/Q372JKHmBhs/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'BzMrbGx83wo',
    snippet: {
      publishedAt: '2020-09-10T17:28:13Z',
      title: 'How to Use Song Maker',
      description:
        'https://musiclab.chromeexperiments.com/Song-Maker/song/5261420504547328 Go to this link to try Song Maker for yourself!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/BzMrbGx83wo/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/BzMrbGx83wo/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/BzMrbGx83wo/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'tvY5Ed7a5Nk',
    snippet: {
      publishedAt: '2020-04-08T20:51:07Z',
      title: 'Everything Grows with Vocals',
      description:
        'Original song by Raffi. https://www.youtube.com/watch?v=ky5TNR_cGYY Arrangement and motions by Ms. Johnson. Slideshow ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/tvY5Ed7a5Nk/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/tvY5Ed7a5Nk/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/tvY5Ed7a5Nk/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'epwyoEfLDJ8',
    snippet: {
      publishedAt: '2020-05-06T21:02:47Z',
      title: 'Violin: Learn to write D E F# on staff!',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/epwyoEfLDJ8/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/epwyoEfLDJ8/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/epwyoEfLDJ8/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'c-OeY2-2EAU',
    snippet: {
      publishedAt: '2020-09-14T19:41:01Z',
      title: 'Funga Alafia Greeting',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/c-OeY2-2EAU/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/c-OeY2-2EAU/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/c-OeY2-2EAU/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'o-uqmZ5puw0',
    snippet: {
      publishedAt: '2020-10-26T19:50:21Z',
      title: 'Move-It: Waltz in A Flat',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/o-uqmZ5puw0/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/o-uqmZ5puw0/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/o-uqmZ5puw0/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: '2d2D0xiuBSM',
    snippet: {
      publishedAt: '2022-08-26T17:05:43Z',
      title: "A fost odat' un om ciudat plus cat bloopers!",
      description:
        'A nonsense song- un cântec jucăuși! Inspired from the song in English: "There was a man and he was mad!" I created my own ...',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/2d2D0xiuBSM/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/2d2D0xiuBSM/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/2d2D0xiuBSM/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'MT5viy0crGs',
    snippet: {
      publishedAt: '2020-04-14T01:23:23Z',
      title: 'Music Class: I Know a Shy Fellow Who Swallowed a Cello',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/MT5viy0crGs/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/MT5viy0crGs/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/MT5viy0crGs/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'y0UWs-ZV_9U',
    snippet: {
      publishedAt: '2020-11-09T20:47:18Z',
      title: 'Glockenspiel First Songs: Left Hand and Right Hand',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/y0UWs-ZV_9U/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/y0UWs-ZV_9U/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/y0UWs-ZV_9U/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'NqfeqBngTUg',
    snippet: {
      publishedAt: '2020-04-14T20:24:51Z',
      title: 'Human Xylophone Part 2: Paper Xylophone!',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/NqfeqBngTUg/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/NqfeqBngTUg/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/NqfeqBngTUg/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  },
  {
    videoId: 'Tmk9uluAddw',
    snippet: {
      publishedAt: '2020-04-10T23:28:31Z',
      title: 'Human Xylophone Part 1: Body Xylophone',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/Tmk9uluAddw/default.jpg',
          width: 120,
          height: 90
        },
        medium: {
          url: 'https://i.ytimg.com/vi/Tmk9uluAddw/mqdefault.jpg',
          width: 320,
          height: 180
        },
        high: {
          url: 'https://i.ytimg.com/vi/Tmk9uluAddw/hqdefault.jpg',
          width: 480,
          height: 360
        }
      }
    }
  }
]

export default YOUTUBE_VIDEOS
